import { render, staticRenderFns } from "./rawData.vue?vue&type=template&id=4984388a&scoped=true"
import script from "./rawData.vue?vue&type=script&lang=js"
export * from "./rawData.vue?vue&type=script&lang=js"
import style0 from "./rawData.vue?vue&type=style&index=0&id=4984388a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4984388a",
  null
  
)

export default component.exports